import {
  getKnowledgeArticleLink,
  getKnowledgeIndexLink,
} from '../../utils/knowledge/knowledgeArticles';
import { getKnowledgeUiCopy, KnowledgeLocale } from '../../utils/knowledge/knowledgeCopy';
import { KnowledgeChannel } from '../../utils/knowledge/types';
import {
  KnowledgeBreadcrumbCurrent,
  KnowledgeBreadcrumbLink,
  KnowledgeBreadcrumbNav,
  KnowledgeBreadcrumbSep,
  KnowledgeCategoryPageTitle,
  KnowledgeFullArticleItem,
  KnowledgeFullArticleLink,
  KnowledgeFullArticleList,
  KnowledgeMainColumn,
  KnowledgePageLayout,
} from './KnowledgeCentre.styles';
import { KnowledgeHelpSidebar } from './KnowledgeHelpSidebar';

interface KnowledgeCategoryPageProps {
  locale: KnowledgeLocale;
  channel: KnowledgeChannel;
  categoryName: string;
  articles: { urlName: string; title: string }[];
  topArticles: { urlName: string; title: string }[];
}

export const KnowledgeCategoryPage = ({
  locale,
  channel,
  categoryName,
  articles,
  topArticles,
}: KnowledgeCategoryPageProps) => {
  const channelProp = { $channel: channel };
  const ui = getKnowledgeUiCopy(locale);
  const indexHref = getKnowledgeIndexLink(locale, channel);

  return (
    <KnowledgePageLayout {...channelProp}>
      <KnowledgeMainColumn>
        <KnowledgeBreadcrumbNav>
          <KnowledgeBreadcrumbLink href={indexHref}>{ui.home}</KnowledgeBreadcrumbLink>
          <KnowledgeBreadcrumbSep>›</KnowledgeBreadcrumbSep>
          <KnowledgeBreadcrumbCurrent>{categoryName}</KnowledgeBreadcrumbCurrent>
        </KnowledgeBreadcrumbNav>
        <KnowledgeCategoryPageTitle>{categoryName}</KnowledgeCategoryPageTitle>
        <KnowledgeFullArticleList>
          {articles.map(({ urlName, title }) => (
            <KnowledgeFullArticleItem key={urlName}>
              <KnowledgeFullArticleLink href={getKnowledgeArticleLink(locale, channel, urlName)}>
                {title}
              </KnowledgeFullArticleLink>
            </KnowledgeFullArticleItem>
          ))}
        </KnowledgeFullArticleList>
      </KnowledgeMainColumn>
      <KnowledgeHelpSidebar channel={channel} locale={locale} topArticles={topArticles} />
    </KnowledgePageLayout>
  );
};
